<template>
  <div>
    <Navbar />
    <section class="category-page">
      <Header
        formID="get-offer-credit"
        :formData="formData"
        :insuranceType="insuranceType"
        approveRoute="alacak-sigortasi-teklif-onay"
      />
      <get-quote :quoteCard="quoteCard" />
      <category-info :categoryInfo="categoryInfo" />
      <app-contracted-insurance-companies :buttons="buttonData" />
      <frequently-asked-questions
        :faqTitle="faqTitle"
        :faqTitleDesc="faqTitleDesc"
        :questions="questions"
      />
    </section>
    <Footer />
  </div>
</template>

<script>
import Navbar from '@/component/navbar/Navbar'
import Header from '@/component/categories/Header'
import GetQuote from '@/component/categories/GetQuote'
import categoryInfo from '@/component/categories/CategoryInfo'
import appContractedInsuranceCompanies from '@/component/contracted-insurance-companies/AppContractedInsuranceCompanies'
import frequentlyAskedQuestions from '@/component/expansional-question-panel/AppQuestionPanel'
import CreditInsuranceData from '@/data/category-page-data/CreditInsurance'
import Footer from '@/component/footer/Footer'
import QuotationType from '@/data/QuotationType'
import { filteredButtons } from '@/mixins/FilteredButtons'

export default {
  metaInfo: {
    title: 'Devlet Destekli (Ticari) Alacak Sigortası Teklifleri',
    meta: [
      {
        name: 'description',
        content:
          'Alacak sigortası genel şartlarına uygun ticari alacak sigortası yapan şirketleri (firmaları) web sitemizden online fiyat alarak, kolayca karşılaştırabilirsiniz.'
      }
    ]
  },
  mixins: [filteredButtons],
  name: 'CreditInsurance',
  components: {
    Navbar,
    Header,
    GetQuote,
    categoryInfo,
    appContractedInsuranceCompanies,
    frequentlyAskedQuestions,
    Footer
  },
  data () {
    return {
      insuranceType: QuotationType.CREDIT,
      categoryInfo: CreditInsuranceData.categoryInfo,
      getPrice: CreditInsuranceData.getPrice,
      faqTitle: CreditInsuranceData.faqTitle,
      faqTitleDesc: CreditInsuranceData.faqTitleDesc,
      questions: CreditInsuranceData.questions,
      formData: {
        description: {
          upperText: 'KOBİ’lere yönelik',
          title: 'Alacak Sigortası Fiyatları',
          bottomText: 'Kapsamlı Alacak Sigortası Tekliflerini Karşılaştırın'
        },
        button: 'TEKLİF AL',
        fullname: true,
        identity: true,
        phone: true,
        email: true
      },
      quoteCard: {
        title:
          'Alokasko’dan Alacak Sigortası Tekliflerini Karşılaştırmak Çok Kolay!',
        description:
          'Devlet destekli alacak sigortası ile alacaklarınızı güvence altına alın.',
        content: [
          {
            id: 1,
            icon: 'fas fa-file-alt',
            title: 'Alacaklarınız Güvence Altında',
            desc:
              'Vadeli satışlarınızdan kaynaklı ortaya çıkan alacaklarınız alacak sigortası ile güvence altında.'
          },
          {
            id: 2,
            icon: 'fab fa-cc-visa',
            title: 'Nakit Akışını Düzenleme ',
            desc:
              'İşletmenizin öngörülemeyen alacak sorunları koruma altında. Alacak sigortası ile finansal durumunuzu güçlendirin.'
          },
          {
            id: 3,
            icon: 'fas fa-clipboard-check',
            title: 'Risk Yönetimi',
            desc:
              'Müşterilerinizi ve şirketin finansal durumunu izlenerek risklerinizi yönetmeye yardımcı olur.'
          },
          {
            id: 4,
            icon: 'fas fa-users-cog',
            title: 'Uzman Desteği',
            desc:
              'Ticari borçların ödenmeme riskine karşı satın alacağınız alacak sigortası ile ilgili merak ettiğiniz soruları uzmanlarımızdan öğrenebilirsiniz.'
          }
        ]
      }
    }
  },
  mounted () {
    this.filterButtons('Alacak Sigortası')
  }
}
</script>
<style lang="scss">
@import '@/css/app.scss';
</style>
